// @flow

// x-Axis change
export const RISK_CHART_X_CHANGE = 'RISK_CHART_X_CHANGE'
export type RISK_CHART_X_CHANGE_TYPE = {
  type: 'RISK_CHART_X_CHANGE',
  payload: {
    allX: number[]
  }
}

export const RISK_X_CHANGE = (allX: number[]): RISK_CHART_X_CHANGE_TYPE => ({
  type: RISK_CHART_X_CHANGE,
  payload: { allX }
})

// y-Axis change
export const RISK_CHART_Y_CHANGE = 'RISK_CHART_Y_CHANGE'
export type RISK_CHART_Y_CHANGE_TYPE = {
  type: 'RISK_CHART_Y_CHANGE',
  payload: {
    allY: number[],
    index: number
  }
}

export const RISK_Y_CHANGE = (allY: number[], index: number): RISK_CHART_Y_CHANGE_TYPE => ({
  type: RISK_CHART_Y_CHANGE,
  payload: { allY, index }
})

// price & pnl array change
export const RISK_CHART_DATA_CHANGE = 'RISK_CHART_DATA_CHANGE'
export type RISK_CHART_DATA_CHANGE_TYPE = {
  type: 'RISK_CHART_DATA_CHANGE',
  payload: {
    data: Object[]
  }
}

export const RISK_DATA_CHANGE = (data: Object[]): RISK_CHART_DATA_CHANGE_TYPE => ({
  type: RISK_CHART_DATA_CHANGE,
  payload: { data }
})

// checked trade leg list change
export const RISK_CHART_CHECKED_CHANGE = 'RISK_CHART_CHECKED_CHANGE'
export type RISK_CHART_CHECKED_CHANGE_TYPE = {
  type: 'RISK_CHART_CHECKED_CHANGE',
  payload: {
    checkedList: number[]
  }
}

export const RISK_CHECKED_CHANGE = (checkedList: number[]): RISK_CHART_CHECKED_CHANGE_TYPE => ({
  type: RISK_CHART_CHECKED_CHANGE,
  payload: { checkedList }
})

// list of open trades
export const UPDATE_ALL_OPEN_TRADES = 'risk:openTrades'
export type UPDATE_ALL_OPEN_TRADES_TYPE = {
  type: 'risk:openTrades',
  payload: {
   openTrades: Object[] 
  }
}

export const updateAllOpenTrades = (openTrades: Object[]): UPDATE_ALL_OPEN_TRADES_TYPE => ({
  type: UPDATE_ALL_OPEN_TRADES,
  payload: { openTrades }
})

// selected open trade
export const UPDATE_SELECTED_TRADE = 'risk:updateSelectedTrade'
export type UPDATE_SELECTED_TRADE_TYPE = {
  type: 'risk:updateSelectedTrade',
  payload: {
    selectedTrade: Object
  }
}

export const updateSelectedTrade = (selectedTrade: Object): UPDATE_SELECTED_TRADE_TYPE => ({
  type: UPDATE_SELECTED_TRADE,
  payload: { selectedTrade }
})

// index of selected open trade
export const UPDATE_SELECTED_TRADE_INDEX = 'risk:updateSelectedTradeIndex'
export type UPDATE_SELECTED_TRADE_INDEX_TYPE = {
  type: 'risk:updateSelectedTradeIndex',
  payload: {
    selectedIndex: number[]
  }
}

export const updateSelectedTradeIndex = (selectedIndex: number[]): UPDATE_SELECTED_TRADE_INDEX_TYPE => ({
  type: UPDATE_SELECTED_TRADE_INDEX,
  payload: { selectedIndex }
})

// date filter for second pnl line
export const UPDATE_SELECTED_DATE_FILTER = 'risk:updateSelectedDateFilter'
export type UPDATE_SELECTED_DATE_FILTER_TYPE = {
  type: 'risk:updateSelectedDateFilter',
  payload: {
    selectedDateFilter: Object
  }
}

export const updateSelectedDateFilter = (selectedDateFilter: Object): UPDATE_SELECTED_DATE_FILTER_TYPE => ({
  type: UPDATE_SELECTED_DATE_FILTER,
  payload: { selectedDateFilter }
})

// y-Axis for second (selected date) pnl line
export const UPDATE_SELECTED_DATE_Y = 'risk:selectedDateUpdateY'
export type UPDATE_SELECTED_DATE_Y_TYPE = {
  type: 'risk:selectedDateUpdateY',
  payload: {
    dateFilterY: number[],
    index: number
  }
}

export const updateSelectedDateY = (dateFilterY: number[], index: number): UPDATE_SELECTED_DATE_Y_TYPE => ({
  type: UPDATE_SELECTED_DATE_Y,
  payload: { dateFilterY, index }
})


// WEBPACK FOOTER //
// ./src/actions/risk/index.js